module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Direction1-6b23d7dd115172c3083519243f7ddbf9.svg";